document.addEventListener('DOMContentLoaded', function() {
    let checker = document.getElementById('flexi-checker');

    // Check immediately if checker exists
    if (!checker) {
        setTimeout(function() {
            // Check again if checker still doesn't exist
            console.log("Checking for flexi-checker after 10 seconds...");
            checker = document.getElementById('flexi-checker');
            if (!checker) {
                displayBanner();
                console.log("flexi-checker not found. Displaying banner...");
            }
        }, 10000); // 10 seconds
    }

    function displayBanner() {
        var flexiBanner = document.getElementById('flexi-embed-banner');
        if (flexiBanner) {
            flexiBanner.style.display = 'block';
        }
    }
});


const onClickAccordionHeader = e => {
    const parentAccordion = e.currentTarget.closest('.accordion');
    const accordionItems = parentAccordion.querySelectorAll('.accordion-item');

    if (e.currentTarget.parentNode.classList.contains('active')) {
      e.currentTarget.parentNode.classList.remove("active");
    } else {
      Array.prototype.forEach.call(accordionItems, e => e.classList.remove('active'));
      e.currentTarget.parentNode.classList.add("active");
    }
};

const initAccordion = () => {
    const accordionItem = document.querySelectorAll('.accordion-item');
    Array.prototype.forEach.call(accordionItem, e => e.querySelector('.accordion-header').addEventListener('click', onClickAccordionHeader, false));
};

document.addEventListener('DOMContentLoaded', initAccordion);
  

document.addEventListener("DOMContentLoaded", function() {
// Check if the URL contains '#view-product'
if(window.location.hash === '#scroll-point') {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Add event listener to all links with href '#view-product'
const viewProductLinks = document.querySelectorAll("a[href='#scroll-point']");
viewProductLinks.forEach(function(viewProductLink) {
    viewProductLink.addEventListener("click", function(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
});

/* BEGIN RG Rebuy Smart Cart flexi fallback fix — 2026-04-20
 * Ensures Smart Cart can open from cached non-product pages.
 * Rollback: remove this BEGIN/END block from assets/flexi-javascript.js.
 */
(function () {
  if (window.RGRebuySmartCartAppFallbackLoaded) return;
  window.RGRebuySmartCartAppFallbackLoaded = true;

  var REBUY_SRC = 'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=concealment-express.myshopify.com';
  var CART_SELECTOR = 'a.icon-cart.mini_cart.dropdown_link[href*="/cart"], a[href="/cart"], a[href*="/cart?"]';

  function hasRebuyScript() {
    return Array.prototype.some.call(document.scripts, function (script) {
      return script.src && script.src.indexOf('cdn.rebuyengine.com/onsite/js/rebuy.js') !== -1;
    });
  }

  function loadRebuyIfMissing() {
    if (window.Rebuy || hasRebuyScript()) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = REBUY_SRC;
    script.setAttribute('data-rg-rebuy-flexi-fallback', 'true');
    (document.head || document.documentElement).appendChild(script);
  }

  function openSmartCartOrFallback() {
    loadRebuyIfMissing();
    var attempts = 0;
    (function tryOpen() {
      attempts += 1;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
        return;
      }
      if (attempts >= 70) {
        window.location.href = '/cart';
        return;
      }
      window.setTimeout(tryOpen, 100);
    })();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest(CART_SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openSmartCartOrFallback();
  }, true);

  loadRebuyIfMissing();
})();
/* END RG Rebuy Smart Cart flexi fallback fix — 2026-04-20 */

